
import { mapActions } from 'vuex'
export default {
  props: {
    actionSend: {
      type: Function,
      default: () => {},
    },
    buttonLoad: Boolean,
    value: {
      type: Object,
      default() {
        return {
          nome: '',
          telefone: '',
          email: '',
          endereco: {
            estado: '',
            cidade: '',
          },
          comoConheceu: '',
          observacao: '',
        }
      },
    },
  },
  data() {
    return {
      statesSearch: [],
      citysSearch: [],
      loadingInputState: true,
      loadingInputCity: false,
      emailRules: [
        (v) => !!v || 'O e-mail é obrigatório',
        (v) => /.+@.+\..+/.test(v) || 'E-mail deve ser válido',
      ],
    }
  },
  async mounted() {
    await this.loadState()
  },
  methods: {
    ...mapActions('actions-site', ['fetchStateBrazil', 'fetchCityBrazil']),
    async loadState() {
      try {
        const data = await this.fetchStateBrazil()
        this.statesSearch = data
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingInputState = false
      }
    },
    async stateSelected() {
      this.loadingInputCity = true
      try {
        const city = this.value.endereco.estado.id
        const data = await this.fetchCityBrazil(city)
        this.citysSearch = data
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingInputCity = false
      }
    },
  },
}
